// Séparateur utilisé dans le chemin pour identifier une valeur dans le modèle
export const MODEL_TARGET_PATH_SEPARATOR = '/';
